import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function dateToNgbDate(
  date: Date | null | undefined
): NgbDateStruct | null {
  if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
}

export function ngbDateToDate(
  struct: NgbDateStruct | null | undefined
): Date | null {
  if (!struct?.year || !struct?.month || !struct?.day) {
    return null;
  }

  return new Date(struct.year, struct.month - 1, struct.day);
}

export function datesToNgbRange(
  dates: Date[] | null | undefined
): { start: NgbDateStruct | null; end: NgbDateStruct | null } {
  return {
    start: dateToNgbDate(dates?.[0] ?? null),
    end: dateToNgbDate(dates?.[1] ?? null),
  };
}

export function ngbRangeToDates(
  start: NgbDateStruct | null | undefined,
  end: NgbDateStruct | null | undefined
): Date[] {
  const startDate = ngbDateToDate(start);
  const endDate = ngbDateToDate(end);

  if (startDate && endDate) {
    return [startDate, endDate];
  }

  if (startDate) {
    return [startDate];
  }

  return [];
}
